export default __webpack_public_path__ + "static/media/daliy-flash.54c3f470.png";